import { normalizePermissionList, normalizePermissionSlug } from './permissionRegistry';

const STORAGE_KEY = 'permissions_preview';

/**
 * Локальная подмена прав. Меняет только раскладку интерфейса на этой машине:
 * токен и проверки на бэкенде остаются прежними. Нужна, чтобы смотреть
 * интерфейс позиции, пока права ещё не раздали.
 */
export function getPermissionsPreview(): string[] {
  if (typeof localStorage === 'undefined') return [];
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return [];
  return normalizePermissionList(raw.split(','));
}

export function setPermissionsPreview(slugs?: string[] | string | null): void {
  if (typeof localStorage === 'undefined') return;
  const list = Array.isArray(slugs)
    ? normalizePermissionList(slugs)
    : normalizePermissionList([normalizePermissionSlug(slugs)]);
  if (list.length) {
    localStorage.setItem(STORAGE_KEY, list.join(','));
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export interface EffectivePermissions {
  /** Права, по которым собран интерфейс. */
  permissions: string[];
  /** Права, пришедшие с бэкенда. */
  actual: string[];
  isPreview: boolean;
}

export function resolveEffectivePermissions(actualRaw: unknown): EffectivePermissions {
  const actual = normalizePermissionList(actualRaw);
  const preview = getPermissionsPreview();
  if (preview.length && preview.join(',') !== actual.join(',')) {
    return { permissions: preview, actual, isPreview: true };
  }
  return { permissions: actual, actual, isPreview: false };
}

/**
 * Раскладка и ключи access считаются один раз при старте приложения, поэтому
 * подмена применяется перезагрузкой — как и переключение контекста.
 */
export function applyPermissionsPreviewAndReload(slugs?: string[] | string | null): void {
  setPermissionsPreview(slugs);
  window.location.reload();
}
